import { motion } from "framer-motion";
import { ArrowUpRight, PhoneCall, ClipboardList } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export const EnrollmentCTA = () => (
  <section id="enrollment" className="relative overflow-hidden bg-white py-28 sm:py-36" data-testid="enrollment-section">
    <div aria-hidden className="pointer-events-none absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-sky-100 blur-3xl" />

    <div className="relative mx-auto max-w-4xl px-6 sm:px-10">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: EASE }}
        className="font-mono text-[11px] font-semibold uppercase tracking-[0.3em] text-amber-700"
      >
        Enrollment — 2026 Batch
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ delay: 0.1, duration: 0.8, ease: EASE }}
        className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-slate-900 sm:text-4xl lg:text-5xl"
        data-testid="enrollment-headline"
      >
        Submit the form to enroll for OTET 1 and 2 batch.
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ delay: 0.2, duration: 0.8, ease: EASE }}
        className="mt-5 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg"
      >
        One short form and you are in. Fill it, and your mentor
        reaches out with your batch plan.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ delay: 0.3, duration: 0.8, ease: EASE }}
        className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center"
      >
        <a
          href="https://tally.so/r/J9yWGo"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="tally-enroll-link"
          className="group inline-flex items-center justify-center gap-2 rounded-full bg-sky-700 px-8 py-4 text-sm font-bold text-white shadow-lg shadow-sky-700/20 transition-colors duration-200 hover:bg-sky-800"
        >
          <ClipboardList size={17} />
          Fill the Enrollment Form
          <ArrowUpRight size={16} className="transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </a>
      </motion.div>

      <motion.a
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ delay: 0.4, duration: 0.8, ease: EASE }}
        href="https://wa.me/917751946736"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-contact-link"
        className="group mt-8 flex max-w-md items-center gap-5 rounded-3xl border border-slate-200 bg-slate-50/70 p-6 transition-colors duration-200 hover:border-emerald-300 hover:bg-emerald-50/60"
      >
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-emerald-600 text-white">
          <PhoneCall size={20} />
        </span>
        <span>
          <span className="block font-mono text-xl font-bold tracking-wider text-slate-900" data-testid="whatsapp-contact-number">
            77519 46736
          </span>
          <span className="mt-1 inline-block rounded-full bg-amber-100 px-3 py-0.5 text-[11px] font-bold uppercase tracking-widest text-amber-800">
            WhatsApp message only
          </span>
        </span>
      </motion.a>
    </div>
  </section>
);
